// extracted by mini-css-extract-plugin
module.exports = {"inactive":"style_inactive__1r1VP","attunements":"style_attunements__1BLXa"};